// ============================================================================
// services/reminderModule/reminderExclusionService.js
// ============================================================================
// All reminders-exclusion + reminder-setup helper calls. Every URL comes from
// REMINDER_URLS in apiConfig (which carries BASE_URL incl. /api), so nothing
// uses a bare path. The upload uses multipart/form-data; the rest are JSON.
// ============================================================================

import { REMINDER_URLS } from "../apiConfig.js";
import apiClient from "../apiInstance.js";

// Upload + reconcile a reminders exclusion CSV (full replace).
// args: { file: File, reason?: string }
// returns: { message, accepted, rejected, rowErrors }
export const uploadReminderExclusion = async ({ file, reason } = {}) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (reason) formData.append("reason", reason);

    const response = await apiClient.post(
      REMINDER_URLS.UPLOAD_REMINDER_EXCLUSION,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading reminder exclusion list", error);
    throw error;
  }
};

// Campaign send-time preview (Reminders.jsx "Check campaign send times").
// returns: { firstInitialUtc, lastInitialUtc, activeCount }
export const fetchCampaignMessageTimes = async (campaignId, channel) => {
  try {
    const response = await apiClient.get(REMINDER_URLS.CAMPAIGN_TIMES, {
      params: { campaignId, channel },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching campaign message times", error);
    throw error;
  }
};

// Comparison-day table data (today vs prior upload day).
// returns: { todayDate, priorDate, today:[], prior:[] }
export const fetchReminderExclusionDays = async () => {
  try {
    const response = await apiClient.get(REMINDER_URLS.EXCLUSION_DAYS);
    return response.data;
  } catch (error) {
    console.error("Error fetching exclusion comparison days", error);
    throw error;
  }
};

// Generate exclusion list by comparison. { confirm: false } = preview (no write),
// { confirm: true } = commit via the reconcile proc.
// returns: { preview|committed, todayDate, priorDate, droppedCount, message }
export const generateReminderExclusion = async ({ confirm = false } = {}) => {
  try {
    const response = await apiClient.post(REMINDER_URLS.GENERATE_EXCLUSION, { confirm });
    return response.data;
  } catch (error) {
    console.error("Error generating reminder exclusion list", error);
    throw error;
  }
};

// Audit: per-campaign counts + full detail (CSV source).
// returns: { summary:[], detail:[], totals:{} }
export const fetchReminderExclusionAudit = async () => {
  try {
    const response = await apiClient.get(REMINDER_URLS.EXCLUSION_AUDIT);
    return response.data;
  } catch (error) {
    console.error("Error fetching reminder exclusion audit", error);
    throw error;
  }
};